import React from 'react';
import { createPortal } from 'react-dom';

const id = 'navigation-portal';
/**
 * Portal that renders children into a DOM node outside the React app.
 *
 * Uses the div with id "navigation-portal" defined in _Navigation.cshtml to render
 * UI above the navigation bar, bypassing the normal React component hierarchy.
 * Returns null if the target element doesn't exist.
 */
const NavigationPortal = ({ children }) => {
  const element = document.getElementById(id);

  if (!element) return null;

  return createPortal(children, element);
};

export default NavigationPortal;
